import { render } from "./Clip.vue?vue&type=template&id=55699426&scoped=true&ts=true"
import script from "./Clip.vue?vue&type=script&lang=ts"
export * from "./Clip.vue?vue&type=script&lang=ts"

import "./Clip.vue?vue&type=style&index=0&id=55699426&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55699426"]])

export default __exports__